import zod from 'zod'

export const formSchema = zod.object({
  url: zod.string().min(1, 'Field is required'),
})

export type FormType = zod.TypeOf<typeof formSchema>
